export const reports = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve">
<g>
<g>
   <g id="XMLID_38_">
       <g>
           <rect x="200" y="10" style="fill:#99A0A4;" width="90" height="35"/>
           <polygon style="fill:#99A0A4;" points="480,335 480,370 10,370 10,335 25,335 465,335 				"/>
           <polygon style="fill:#252360;" points="465,45 465,335 25,335 25,45 200,45 290,45 				"/>
       </g>
       <path style="fill:#231F20;" d="M480,325h-5V45c0-5.523-4.477-10-10-10H300V10c0-5.523-4.477-10-10-10h-90
           c-5.523,0-10,4.477-10,10v25H25c-5.523,0-10,4.477-10,10v280h-5c-5.523,0-10,4.477-10,10v35c0,5.523,4.477,10,10,10h152.338
           l-50.913,84.855l17.149,10.29L185.662,380H235v110h20V380h49.338l57.087,95.145l17.149-10.29L327.662,380H480
           c5.523,0,10-4.477,10-10v-35C490,329.477,485.523,325,480,325z M210,20h70v15h-70V20z M35,55h420v270H35V55z M470,360H20v-15h450
           V360z"/>
   </g>
</g>
<g id="XMLID_37_">
   <g>
       <rect x="300" y="90" style="fill:#287E40;" width="50" height="35"/>
       <rect x="220" y="150" style="fill:#287E40;" width="50" height="35"/>
       <rect x="300" y="125" style="fill:#43B05C;" width="50" height="165"/>
       <rect x="220" y="185" style="fill:#43B05C;" width="50" height="105"/>
       <rect x="140" y="245" style="fill:#43B05C;" width="50" height="45"/>
       <rect x="140" y="210" style="fill:#287E40;" width="50" height="35"/>
   </g>
   <g>
       <path style="fill:#231F20;" d="M190,200h-50c-5.523,0-10,4.477-10,10v80c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10v-80
           C200,204.477,195.523,200,190,200z M180,220v15h-30v-15H180z M150,280v-25h30v25H150z"/>
       <path style="fill:#231F20;" d="M270,140h-50c-5.523,0-10,4.477-10,10v140c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10V150
           C280,144.477,275.523,140,270,140z M260,160v15h-30v-15H260z M230,280v-85h30v85H230z"/>
       <path style="fill:#231F20;" d="M350,80h-50c-5.523,0-10,4.477-10,10v200c0,5.523,4.477,10,10,10h50c5.523,0,10-4.477,10-10V90
           C360,84.477,355.523,80,350,80z M340,100v15h-30v-15H340z M310,280V135h30v145H310z"/>
   </g>
</g>
<g>
   <rect x="65" y="80" style="fill:#231F20;" width="55" height="20"/>
</g>
<g>
   <rect x="65" y="110" style="fill:#231F20;" width="110" height="20"/>
</g>
<g>
   <rect x="65" y="140" style="fill:#231F20;" width="80" height="20"/>
</g>
<g>
   <rect x="155" y="80" style="fill:#231F20;" width="20" height="20"/>
</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>`;
